export default "__VITE_ASSET__C3F$NGs2__"